import {useCallback, useEffect, useState} from 'react'
import {MenuItem} from '../types/MenuItem'
import {getCompanyFeatures, getDashboardMenu } from '../api/index'
import {isSuperAdmin} from '../modules/auth'
import {getToolsMenu, getLojistasMenu, normalizeMenu} from '../data-layer/MenuData'

export const useUsermenuData = () => {
  const [menuData, setMenuData] = useState<MenuItem[]>([])
  const [isFetching, setIsFetching] = useState<boolean>(true)

  const fetchDashboardMenu = useCallback(async () => {
    const response = await getDashboardMenu()
    const menuItems = (response.data || []).filter((x:any) => x.children && x.children.length > 0)
    return menuItems
  }, [])

  const fetchData = useCallback(async () => {
    setIsFetching(true)

    const result = await getCompanyFeatures()
    const features = result.data || [];

    const dashboardMenu = await fetchDashboardMenu()
    const toolsMenu = getToolsMenu(features, isSuperAdmin())
    const lojistasMenu = getLojistasMenu(features)

    const items = normalizeMenu([...dashboardMenu, ...toolsMenu, ...lojistasMenu])

    setMenuData(items)
    setIsFetching(false)
  }, [fetchDashboardMenu])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    menuData,
    isFetching,
  }
}
